import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';

const useStyles = makeStyles((theme) => ({
  root: {},
  menuItem: {
    textTransform: 'capitalize',
  },
}));

const DivisionLevelFilter = (props) => {
  const { className, filtersChange, field, values, ...rest } = props;
  const classes = useStyles();
  
  const levelOptions = [
    { value: 'primaire', label: 'Primaire' },
    { value: 'base', label: 'Base' },
    { value: 'secondaire', label: 'Secondaire' },
    { value: 'bac', label: 'Bac' },
    { value: 'prepa', label: 'Prepa' },
  ];

  const handleChange = (e) => {
    filtersChange({
      [field.name]: e.target.value,
    });
  };

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <FormControl className={classes.formControl} fullWidth variant="outlined" size="small">
        <InputLabel id={field.name + '-label'}>{field.label}</InputLabel>
        <Select
          labelId={field.name + '-label'}
          id={field.name}
          label={field.label}
          value={values[field.name] || ''}
          onChange={handleChange}
        >
          {levelOptions.map((option) => (
            <MenuItem 
              value={option.value} 
              key={option.value} 
              className={classes.menuItem}
            >
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

DivisionLevelFilter.propTypes = {
  className: PropTypes.string,
  filtersChange: PropTypes.func,
  field: PropTypes.object,
  values: PropTypes.object,
};

export default DivisionLevelFilter;
